import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

const fieldAppear = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

export default makeStyles()(theme => ({
  loginContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '90%',
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(8),
    },
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing(33),
    },
  },
  login: {
    margin: theme.spacing(8, 0),
    minWidth: 240,
    width: 480,
  },
  logo: {
    width: 168,
    display: 'block',
    margin: `${theme.spacing(4)} auto ${theme.spacing(6)} auto`,
  },
  box: {
    marginTop: `${theme.spacing(3)} !important`,
    marginLeft: `${theme.spacing(6)} !important`,
    marginBottom: `${theme.spacing(3)} !important`,
    marginRight: `${theme.spacing(6)} !important`,
    padding: '0 !important',
    [theme.breakpoints.down('md')]: {
      margin: `${theme.spacing(4)} !important`,
      padding: '0 !important',
    },
  },
  copy: {
    color: 'rgba(0, 0, 0, 0.6)',
    textAlign: 'center',
    lineHeight: '1.5em',
    margin: `0 auto ${theme.spacing(4)} auto`,
    transition: 'color 1s ease',
    '& span': {
      transition: 'color 1s ease',
    },
  },
  loginButton: {
    textAlign: 'left',
    marginBottom: theme.spacing(4),
  },
}))
